// extracted by mini-css-extract-plugin
export default {"activationContainer":"activation_activationContainer__VwV4K"};